<template>
  <icon-file-doc
    v-if="fileType === 'doc' || fileType === 'docx' || fileType === 'txt'"
  />
  <icon-file-bmp v-else-if="fileType === 'bmp'" />
  <icon-file-pdf v-else-if="fileType === 'pdf'" />
  <icon-file-ppt v-else-if="fileType === 'ppt' || fileType === 'pptx'" />
  <icon-file-xls v-else-if="fileType === 'xls' || fileType === 'xlsx'" />
  <icon-file-zip v-else-if="fileType === 'zip'" />
  <icon-file-img v-else />
</template>

<script>
/* 파일확장자별 이미지아이콘 컴포넌트 */
import IconFileImg from '@/assets/customIcon/file/IconFileImg.vue';
import IconFileBmp from '@/assets/customIcon/file/IconFileBmp.vue';
import IconFileDoc from '@/assets/customIcon/file/IconFileDoc.vue';
import IconFilePdf from '@/assets/customIcon/file/IconFilePdf.vue';
import IconFilePpt from '@/assets/customIcon/file/IconFilePpt.vue';
import IconFileXls from '@/assets/customIcon/file/IconFileXls.vue';
import IconFileZip from '@/assets/customIcon/file/IconFileZip.vue';

export default {
  props: {
    fileType: {
      type: String,
      default: 'txt',
    },
  },
  components: {
    IconFileImg,
    IconFileBmp,
    IconFileDoc,
    IconFilePdf,
    IconFilePpt,
    IconFileXls,
    IconFileZip,
  },
};
</script>

<style></style>
